import posthog from 'posthog-js';

/**
 * Captures a custom event in PostHog
 * Only processes events that include specific action words
 * @param eventName - Name of the event to capture
 * @param properties - Optional properties to include with the event
 */
export const captureEvent = (
  eventName: string,
  properties?: Record<string, unknown>
) => {
  // List of allowed action words
  const allowedActions = [
    'click',
    'submit',
    'create',
    'view',
    'add',
    'invite',
    'update',
    'delete',
    'remove',
    'start',
    'end',
    'cancel',
    'fail',
    'generate',
    'send',
    'login',
    'signup'
  ];

  // Check if the event name contains any of the allowed actions
  const shouldCaptureEvent = allowedActions.some(action =>
    eventName.toLowerCase().includes(action.toLowerCase())
  );

  if (!shouldCaptureEvent) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(
        'Ignoring event:',
        eventName,
        '(does not contain any allowed action words)'
      );
    }
    return;
  }

  if (process.env.NODE_ENV !== 'production')
    return console.log('Capturing event:', eventName, properties);

  posthog.capture(eventName, properties);
};

/**
 * Resets the current user, typically used for logout
 */
export const resetUser = () => {
  if (process.env.NODE_ENV !== 'production')
    return console.log('Resetting user');

  posthog.reset();
};

export const POSTHOG_EVENTS = {
  // Candidate
  START_ONBOARDING: 'start_onboarding', // done
  SUBMIT_ONBOARDING: 'submit_onboarding', // done
  SUBMIT_RESUME: 'submit_resume', // done
  SUBMIT_LINKEDIN: 'submit_linkedin', // done
  UPDATE_RESUME: 'update_resume', // done
  VIEW_FEEDBACK: 'view_feedback', // done
  UPDATE_LINKEDIN: 'update_linkedin',
  CREATE_CANDIDATE: 'create_candidate',
  UPDATE_CANDIDATE: 'update_candidate',
  VIEW_CONTRACTS: 'view_contracts',
  VIEW_CONTRACT: 'view_contract',
  START_CONTRACT: 'start_contract',
  CANCEL_CONTRACT: 'cancel_contract',
  VIEW_BENEFITS: 'view_benefits',
  VIEW_REVIEW: 'view_review',
  VIEW_INTERVIEWS: 'view_interviews',
  VIEW_INTERVIEW: 'view_interview',
  START_INTERVIEW: 'start_interview',
  START_CODING_INTERVIEW: 'start_coding_interview',
  SUBMIT_ASSISTANT_QUESTION: 'submit_assistant_question',
  START_WRAPUP_INTERVIEW: 'start_wrapup_interview',
  SUBMIT_INTERVIEW: 'submit_interview',
  CANCEL_INTERVIEW: 'cancel_interview',
  VIEW_PAYMENTS: 'view_payments',
  VIEW_BONUSES: 'view_bonuses',

  // Company
  CREATE_COMPANY: 'create_company',
  UPDATE_COMPANY: 'update_company',
  VIEW_USERS: 'view_users',
  INVITE_USER: 'invite_user',

  // Both
  VIEW_JOBS: 'view_jobs', // done
  VIEW_JOB: 'view_job',


};
